module.exports = __webpack_public_path__ + "img/id_category.9323a4e4.png";